module.exports = __webpack_public_path__ + "hyperion-v2-static/img/isos-mini.e78c90d5.png";